<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright" id="ch00_fm03_copy"><a id="page_iv"></a>© 2012 The Johns Hopkins University Press</p>
<p class="copyrightt">All rights reserved. Published 2012</p>
<p class="copyrightt">Printed in the United States of America on acid-free paper</p>
<p class="copyrightt">2    4    6    8    9    7    5    3    1</p>
<p class="copyright">The Johns Hopkins University Press</p>
<p class="copyrightt">2715 North Charles Street</p>
<p class="copyrightt">Baltimore, Maryland 21218-4363</p>
<p class="copyrightt"><span class="weblink"><a class="nounder" href="http://www.press.jhu.edu" target="_blank">www.press.jhu.edu</a></span></p>
<p class="copyright"><em>Library of Congress Cataloging-in-Publication Data</em></p>
<p class="copyrightt">Kairoff, Claudia Thomas.</p>
<p class="copyrightt">Anna Seward and the end of the eighteenth century /<br/>Claudia Thomas Kairoff.</p>
<p class="copyrightt">p.    cm.</p>
<p class="copyrightt">Includes bibliographical references and index.</p>
<p class="copyrightt">ISBN-13: 978-1-4214-0328-1 (acid-free paper)</p>
<p class="copyrightt">ISBN-10: 1-4214-0328-5 (acid-free paper)</p>
<p class="copyrightt">1. Seward, Anna, 1742–1809—Criticism and interpretation.<br/>2. England—Intellectual life—18th century. I. Title.</p>
<p class="copyrightt">PR3671.S7Z74     2012</p>
<p class="copyrightt">821′.6—dc22         2011019914</p>
<p class="copyright">A catalog record for this book is available from the British Library.</p>
<p class="copyright">“Anna Seward and the Sonnet: Milton’s Champion” was originally<br/>published in <em>Aphra Behn Online</em> 1 (2011) and is reprinted here<br/>with permission of the editors.</p>
<p class="copyright"><em>Special discounts are available for bulk purchases of this book</em>.</p>
<p class="copyrightt"><em>For more information, please contact Special Sales at 410-516-6936<br/>or specialsales@press.jhu.edu</em>.</p>
<p class="copyright">The Johns Hopkins University Press uses environmentally friendly book<br/>materials, including recycled text paper that is composed of at least<br/>30 percent post-consumer waste, whenever possible.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_copy.vue?520f3bb8